var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('Logo',{staticClass:"logo"}),_c('h1',[_vm._v("Mike Berman")]),_c('h3',[_vm._v("Senior front end developer")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }